export default {
  header: {
    signIn: 'Sign In',
    signUp: 'Sign Up'
  },
  userMenu: {
    wallet: 'Wallet',
    recharge: 'Deposit',
    withdraw: 'Withdraw',
    transaction: 'Transaction',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Vault',
    profile: 'Profile',
    settings: 'Settings',
    taskReward: 'Tasks',
    bonus: 'Bonus',
    affiliate: 'Agent',
    redeemCode: 'Redeem Code',
    signOut: 'Sign Out',
    signOutTitle: 'Sign Out',
    signOutContent: 'Explore a world brimming with rewards and thrilling games!',
    signOutConfirm: 'Sign Out',
    cancel: 'Cancel'
  }
};
